import React, { useCallback, useState } from 'react';
import { GripVertical } from 'lucide-react';

/**
 * HTML5-Drag-Wrapper für Startfenster-Blöcke/Kacheln im Editiermodus.
 */
export function SortableItem({
  id,
  editMode,
  onMove,
  className = '',
  children,
  testId,
}) {
  const [dragging, setDragging] = useState(false);
  const [over, setOver] = useState(false);

  const onDragStart = useCallback((e) => {
    e.dataTransfer.setData('text/plain', id);
    e.dataTransfer.effectAllowed = 'move';
    setDragging(true);
  }, [id]);

  const onDragEnd = useCallback(() => {
    setDragging(false);
    setOver(false);
  }, []);

  const onDragOver = useCallback((e) => {
    if (!editMode) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setOver(true);
  }, [editMode]);

  const onDragLeave = useCallback(() => setOver(false), []);

  const onDrop = useCallback((e) => {
    e.preventDefault();
    setOver(false);
    const fromId = e.dataTransfer.getData('text/plain');
    if (fromId && fromId !== id) onMove?.(fromId, id);
  }, [id, onMove]);

  if (!editMode) {
    return <div className={className} data-testid={testId}>{children}</div>;
  }

  return (
    <div
      className={`relative ${className} ${dragging ? 'opacity-50' : ''} ${over ? 'ring-2 ring-brand-red/40 ring-offset-1 rounded-xl' : ''}`}
      onDragOver={onDragOver}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      data-testid={testId || `sortable-${id}`}
    >
      <button
        type="button"
        draggable
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        className="absolute left-1 top-1 z-10 p-1 rounded bg-white/95 border border-slate-200 shadow-sm text-slate-400 hover:text-brand-red cursor-grab active:cursor-grabbing touch-none"
        title="Ziehen zum Verschieben"
        aria-label="Verschieben"
        data-testid={`drag-handle-${id}`}
        onClick={(e) => e.preventDefault()}
      >
        <GripVertical className="w-4 h-4" />
      </button>
      <div className={editMode ? 'pointer-events-none select-none' : ''}>
        {children}
      </div>
    </div>
  );
}
